import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  NavigationContent,
  Container,
  MobileNavigationContainer,
  ProgressAndHeadingContainer
} from './Navigation.styled';
import { Button } from 'components/v2/Buttons/Button/Button';
import { Heading } from 'components/v2/Typography/Heading';
import { Text } from 'components/v2/Typography/Text';
import { usePatient } from 'hooks/usePatient/usePatient';
import { pageUrl } from 'utilities/pageUrl';
import { useBreakpoints } from 'utilities/useBreakpoints';

import { ProgressTracker } from '../ProgressTracker/ProgressTracker';

interface NavigationProps {
  step?: string | null;
  //TODO: try to remove
  onBack?: () => void;
  forwardFunction?: () => void;
  forwardDisabled?: boolean;
  forwardText?: string;
  isForwardClicked?: boolean;
  isPartnerClinicSearch?: boolean;
}

export const Navigation: React.FC<NavigationProps> = ({
  step,
  onBack,
  forwardFunction,
  forwardText,
  forwardDisabled,
  isPartnerClinicSearch
}) => {
  const navigate = useNavigate();
  const { isDesktop } = useBreakpoints();
  const { patient } = usePatient();

  if (step === 'success') return;

  const showForwardNavigation = Boolean(forwardFunction);

  const onClick = () => {
    onBack?.();

    if (window.history.length <= 1) {
      navigate(pageUrl.dashboard());
    } else {
      navigate(-1);
    }
  };

  return (
    <Container $isPatientLoggedIn={Boolean(patient)}>
      {isDesktop ? (
        <NavigationContent>
          <Button
            label="Back"
            size={isDesktop ? 'md' : 'lg'}
            category="secondary"
            onClick={onClick}
          />
          <ProgressAndHeadingContainer>
            <ProgressTracker step={step} />
            <Heading styledAs="h3" $transform="capitalize" noMargin>
              {step}
            </Heading>
          </ProgressAndHeadingContainer>
          {showForwardNavigation ? (
            <Button
              label={forwardText || 'Continue'}
              size={isDesktop ? 'md' : 'lg'}
              category="primary"
              onClick={forwardFunction}
              isDisabled={forwardDisabled}
            />
          ) : (
            <Text size="lg" fontStyle="regular">
              {isPartnerClinicSearch ? 'Contact clinic to book' : 'Select an Option To Proceed'}
            </Text>
          )}
        </NavigationContent>
      ) : (
        <MobileNavigationContainer>
          {forwardFunction && (
            <Button
              label={forwardText || 'Continue'}
              size={'lg'}
              fullWidth
              category="primary"
              onClick={forwardFunction}
              isDisabled={forwardDisabled}
            />
          )}
          <Button label="Back" size={'lg'} fullWidth category="secondary" onClick={onClick} />
        </MobileNavigationContainer>
      )}
    </Container>
  );
};
